import React from 'react';
import { GiReceiveMoney } from 'react-icons/gi';
import {
  PiChecksBold,
  PiChartLineUpBold,
  PiArrowDownBold,
  PiArrowUpBold,
  PiArrowDownRightBold,
  PiArrowRightBold,
  PiArrowUpRightBold,
  PiArrowsInLineVerticalBold,
  PiArrowsOutLineVerticalBold,
} from 'react-icons/pi';

interface IconProps {
  condition: string;
  className: string;
}

const Icon: React.FC<React.PropsWithChildren<IconProps>> = ({ condition }) => {
  const getIcon = (condition: string) => {
    switch (condition) {
      case 'All':
        return (
          <>
            <PiChecksBold />
          </>
        );
      case 'Bearish':
        return (
          <>
            <PiArrowDownRightBold />
          </>
        );
      case 'Neutral':
        return (
          <>
            <PiArrowRightBold />
          </>
        );
      case 'Bullish':
        return (
          <>
            <PiArrowUpRightBold />
          </>
        );
      case 'Income':
        return (
          <>
            <GiReceiveMoney />
          </>
        );
      case 'Volatile':
        return (
          <>
            <PiArrowsOutLineVerticalBold />
          </>
        );
      case 'Growth':
        return (
          <>
            <PiChartLineUpBold />
          </>
        );
      case 'Very Bearish':
        return (
          <>
            <PiArrowDownBold />
          </>
        );
      case 'Very Bullish':
        return (
          <>
            <PiArrowUpBold />
          </>
        );
      case 'Stable':
        return (
          <>
            <PiArrowsInLineVerticalBold />
          </>
        );
      default:
        return null;
    }
  };

  return <>{getIcon(condition)}</>;
};

export { Icon };
